import React from 'react';
import './Card.css';

const Card = ({ 
  children, 
  title, 
  subtitle,
  icon,
  action,
  className = '',
  variant = 'default',
  padding = 'medium',
  ...props 
}) => {
  return (
    <div className={`card card-${variant} card-padding-${padding} ${className}`} {...props}>
      {(title || action) && (
        <div className="card-header">
          <div className="card-header-content">
            {icon && <span className="card-icon">{icon}</span>}
            <div className="card-header-text">
              {title && <h3 className="card-title">{title}</h3>}
              {subtitle && <p className="card-subtitle">{subtitle}</p>}
            </div>
          </div>
          {action && <div className="card-action">{action}</div>}
        </div>
      )}
      <div className="card-body">
        {children}
      </div>
    </div>
  );
};

export default Card;
